import { EditGuesser, ShowGuesser } from 'react-admin'

import { YoutubeRawImportRowsList } from './YoutubeRawImportRowsList'

export const youtubeRawImportRows = {
  edit: EditGuesser,
  list: YoutubeRawImportRowsList,
  show: ShowGuesser,
}
